<template>
    <div class="loading" v-if="loading.isShow">
        <van-loading 
        class="center"
        :color="'#28B8C3'"
        :text-color="'#28B8C3'"
         vertical size="40px">{{loading.text}}</van-loading>
    </div>
</template>

<script>

import { loadingStore } from '@/store/loading.js';

export default {
    name: 'loading',
    props: [],
    components: {},
    data: function () {
        return {}
    },
    setup() {
        let loading = loadingStore();
        return {
            loading
        }
    },

    mounted: function () {},
    methods: {
    }
}
</script>

<style lang="scss" scoped >
    .loading{
        position:fixed;
        width: 100%;
        left: 0;
        top: 0;
        left: 0;
        bottom: 0;
        z-index: 9999;
        .center{
            top: 50%;
            position:relative;
        }
    }
</style>